import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SyncAdminDialogComponent} from './sync-admin-dialog/sync-admin-dialog.component';

const routes: Routes = [
    {path: 'ngrx-manager/sync-admin-dialog', component: SyncAdminDialogComponent}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class NgrxManagerRoutingModule {
}
